module.exports = __webpack_public_path__ + "static/img/aboutBanner2.5c184d8c.png";